import { identityAccountId } from "../identity-account";
import { roomId } from "../room";
import { timestamp } from "../timestamp";
import { rtmpDestinationEntityId } from "./rtmp-destination-entity-id";
import { rtmpDestinationKey } from "./rtmp-destination-key";
import { rtmpDestinationUrl } from "./rtmp-destination-url";

export const rtmpDestinationEntityRaw = {
  type: "object",
  required: ["id", "url", "key", "identityAccountId", "updatedAt"],
  properties: {
    id: rtmpDestinationEntityId,
    url: rtmpDestinationUrl,
    key: rtmpDestinationKey,
    identityAccountId,
    roomId,
    updatedAt: timestamp
  }
};
